import isMobile, { isMobileVR } from "./isMobile";

export const isDesktop = () => {
  return !isMobile() && !isMobileVR();
};
